<script setup>
// hide_on: null = todos; 'mobile' = só no computador; 'desktop' = só no celular.
import { useI18n } from 'vue-i18n';

defineProps({ modelValue: { type: String, default: null } });
const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();
const OPTIONS = [
  { test: 'vis-all', value: null, label: 'VIS_ALL' },
  { test: 'vis-desktop', value: 'mobile', label: 'VIS_DESKTOP' },
  { test: 'vis-mobile', value: 'desktop', label: 'VIS_MOBILE' },
];
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <span class="text-xs font-medium text-n-slate-11">
      {{ t('EMAIL_TEMPLATES.EDITOR.PROPS.VISIBILITY') }}
    </span>
    <div class="flex gap-0.5 rounded-lg border border-n-weak p-0.5">
      <button
        v-for="o in OPTIONS"
        :key="o.test"
        :data-test="o.test"
        type="button"
        class="flex-1 rounded-md px-2 py-1 text-xs"
        :class="
          modelValue === o.value
            ? 'bg-n-brand/10 text-n-brand'
            : 'text-n-slate-11'
        "
        @click="emit('update:modelValue', o.value)"
      >
        {{ t(`EMAIL_TEMPLATES.EDITOR.PROPS.${o.label}`) }}
      </button>
    </div>
  </div>
</template>
